/** Error message, or String(e) for non-Error throws. */
export const errorMessage = (e: unknown): string =>
	e instanceof Error ? e.message : String(e);

/** `code` carried on `Error#cause`, if any. */
export const errorCauseCode = (e: unknown): string | undefined => {
	const cause = e instanceof Error ? e.cause : undefined;
	if (typeof cause !== "object" || cause === null || !("code" in cause)) {
		return undefined;
	}
	return typeof cause.code === "string" ? cause.code : undefined;
};
